import { IntegrationsService } from 'app/integrations/integration.service';
import { IntegrationPlatformType } from 'app/integrations/models/integration.model';
import { ClientifySpecifics, HubspotSpecifics, IntegromatSpecifics, LiveChatSpecifics, MagentoSpecifics, PipeDriveSpecifics, ShoperSpecifics, ShopifySpecifics, TwoWaySpecifics, ZapierSpecifics, ZendeskSpecifics, } from 'app/integrations/integration-platform-specifics';
import * as i0 from "@angular/core";
import * as i1 from "./integration.service";
var IntegrationPlatformSpecificsFactory = /** @class */ (function () {
    function IntegrationPlatformSpecificsFactory(integrationsService) {
        this.integrationsService = integrationsService;
        this.specifics = new Map([
            [IntegrationPlatformType.SHOPIFY, new ShopifySpecifics()],
            [IntegrationPlatformType.LIVECHAT, new LiveChatSpecifics()],
            [IntegrationPlatformType.PIPEDRIVE, new PipeDriveSpecifics(integrationsService)],
            [IntegrationPlatformType.MAGENTO, new MagentoSpecifics()],
            [IntegrationPlatformType.SHOPER, new ShoperSpecifics()],
            [IntegrationPlatformType.ZENDESK, new ZendeskSpecifics(integrationsService)],
            [IntegrationPlatformType.HUBSPOT, new HubspotSpecifics()],
            [IntegrationPlatformType.ZAPIER, new ZapierSpecifics()],
            [IntegrationPlatformType.TWO_WAY, new TwoWaySpecifics()],
            [IntegrationPlatformType.INTEGROMAT, new IntegromatSpecifics()],
            [IntegrationPlatformType.CLIENTIFY, new ClientifySpecifics()],
        ]);
    }
    IntegrationPlatformSpecificsFactory.prototype.getSpecifics = function (type) {
        return this.specifics.get(type);
    };
    IntegrationPlatformSpecificsFactory.ngInjectableDef = i0.defineInjectable({ factory: function IntegrationPlatformSpecificsFactory_Factory() { return new IntegrationPlatformSpecificsFactory(i0.inject(i1.IntegrationsService)); }, token: IntegrationPlatformSpecificsFactory, providedIn: "root" });
    return IntegrationPlatformSpecificsFactory;
}());
export { IntegrationPlatformSpecificsFactory };
